module.exports = __webpack_public_path__ + "static/img/jkztbj_jcjg_icon10.1.png";